<template>
  <div class="page-container content-430">
    <div class="header-wrapper-430">
      <!-- 搜索模块 -->
      <SearchBlock
        ref="searchBlock"
        :normal-class-edit="true"
        @getSearchValue="handleGetSearch"
      ></SearchBlock>
      <div class="table-title-special-430">
        <div class="title-430">
          <div v-if="selectedColumnKey.length">
            已选{{ selectedColumnKey.length }}天
          </div>
        </div>
        <div class="operation-430">
          <div class="block-right">
            <RadioGroup v-model="actionValue">
              <Radio
                v-for="(item, index) in actionsListShow"
                :key="index"
                :label="item.value"
              >
                {{ item.name }}
              </Radio>
            </RadioGroup>
            <Button
              type="primary"
              :disabled="signIds.length === 0"
              :loading="btnLoading"
              @click="handleEditStatus"
            >批量修改{{
              cellList.length === 0 ? '' : `(${cellList.length})`
            }}</Button>
          </div>
        </div>
      </div>
    </div>
    <div class="table table-box">
      <Table
        ref="recordTable"
        border
        :max-height="500"
        :loading="loading"
        :disabled-hover="true"
        :columns="tableColumnShow"
        :data="tableData"
      ></Table>
      <Page
        :total="pageInfo.total"
        show-total
        show-sizer
        show-elevator
        :page-size-opts="pageSizeOpts"
        :current="pageInfo.pageNum"
        class="page-right"
        @on-change="getNewPage"
        @on-page-size-change="handlePageSize"
      ></Page>
    </div>
    <Modal
      v-model="showSettingReasonModal"
      :width="500"
      title="设置请假原因"
      :footer-hide="true"
    >
      <div>请假原因</div>
      <Input
        v-model="leaveReason"
        :rows="3"
        maxlength="20"
        show-word-limit
        type="textarea"
        placeholder="请输入请假原因"
        style="width: 400px"
      ></Input>
      <div class="operation-430">
        <Button class="search-430" @click="handleCancel">取消</Button>
        <Button
          class="search-430"
          type="primary"
          @click="handleChangeLeaveReason"
        >确定</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import SearchBlock from '../assets/components/SearchBlock.vue';
import { getDaysInMonth, getWeekText, isPassExpectTime } from '@/utils/utils';
import eduCenter from '@/request/eduCenter/index.js';
import {
  signStatusList,
  changeDictionaries,
  hasRefundTallyStsList
} from '@/utils/dictionary.js';
import courseSchedulCenter from '@/request/courseSchedulCenter/index.js';
export default {
  components: {
    SearchBlock
  },
  data() {
    return {
      portOrg: -1,
      schoolId: '',
      tableColumn: [
        {
          title: '学生姓名',
          key: 'studentName',
          minWidth: 100,
          align: 'center',
          fixed: 'left',
          className: 'table-left-column table-left-column-font'
        },
        {
          title: '年级班级',
          key: 'gradeAndClass',
          minWidth: 140,
          align: 'center',
          fixed: 'left',
          className: 'table-left-column'
        }
      ],
      tableColumnShow: [],
      tableData: [],
      loading: false,
      pageInfo: {
        total: 0,
        pageSize: 10,
        pageNum: 1
      },
      pageSizeOpts: [10, 20, 50, 100],
      dayObj: {},
      searchKey: ['schoolId', 'classroomName', 'gradeId', 'classId', 'studentName', 'yearCode', 'termCode', 'classType'],
      searchParams: null, // 拿到的搜索参数
      percentModalShow: false,
      downLoadPersent: 0, // 下载进度调
      percentInterVal: null,
      source: null,
      actionValue: 1,
      actionsListShow: [
        {
          value: 1,
          name: '修改为已签到'
        },
        {
          value: 2,
          name: '修改为请假（不退款）'
        },
        {
          value: 4,
          name: '修改为请假（可退款）'
        },
        // {
        //   value: 3,
        //   name: '修改为未签到'
        // }
        {
          value: 5,
          name: '修改为缺勤'
        }
      ],
      cellList: [], // 选中的节次数据
      selectedColumnKey: [], // 选中的列
      btnLoading: false,
      showSettingReasonModal: false, // 设置请假原因
      leaveReason: '',
      selectLeaveIndex: -1
    };
  },
  computed: {
    ...mapState(['userInfo', 'schoolIdForState']),
    signIds() {
      return this.cellList.map(item => {
        return item.signId;
      });
    },
    actionValueStr() {
      let str = '';
      switch (Number(this.actionValue)) {
        case 1:
          str = '修改为已签到';
          break;
        case 2:
          str = '修改为请假';
          break;
        case 3:
          str = '修改为未签到';
          break;
        case 4:
          str = '修改为请假（可退款）';
          break;
        case 5:
          str = '修改为缺勤';
          break;
        default:
          break;
      }
      return str;
    }
  },
  watch: {
    // 切换状态的时候,将已选择的清空
    actionValue(newVal) {
      this.cellList = [];
      this.selectedColumnKey = [];
      console.log(this.tableData);
      if (newVal === 4) {
        const content = `<p>（1）标记成：请假（可退款）将自动为学生生成一条请假单，并<span style="color:red">自动审批通过</span>且设置成<span style="color:red">该节次可退款，</span>标记后，该考勤状态不可修改，请设置前仔细核对。</p><p>（2）若意外操作导致退款，可通过：<span style="color:red">教务中心</span>--<span style="color:red">学生请假</span>--<span style="color:red">设置请假单</span>可退款状态。</p>`;
        this.$Modal.info({
          title: '提示',
          content: content
        });
      }
    }
  },
  created() {
    this.portOrg = Number(localStorage.getItem('portOrg'));
    this.$nextTick(() => {
      if (this.portOrg === 2) {
        this.schoolId = this.userInfo.orgId;
      } else {
        // this.schoolId = localStorage.getItem('schoolId') ? localStorage.getItem('schoolId') : '';
        this.schoolId = this.schoolIdForState ? this.schoolIdForState : '';
      }
      this.$refs.searchBlock.getSchoolId(this.schoolId);
    });
  },
  mounted() {
    this.$eventHub.$on('changeSchool', id => {
      console.log('一进来拿到id', id);
      this.schoolId = id;
      this.$refs.searchBlock.getSchoolId(this.schoolId);
    });
    // this.getNowDayStr();
  },
  destroyed() {
    this.$eventHub.$off('changeSchool');
  },
  methods: {
    // 批量修改状态
    handleEditStatus() {
      const index = this.cellList.findIndex(item => {
        return +item.lockState > 0;
      });
      // lockState 1：不能改 0：能改
      if (index > -1 && +this.actionValue === 4) {
        return this.$Message.error('课程节次已生成账单，不可调整考勤状态！');
      }
      const params = {
        schoolId: this.searchParams.schoolId,
        termCode: this.searchParams.termCode,
        yearCode: this.searchParams.yearCode,
        signIds: this.signIds
      };
      this.btnLoading = true;
      switch (Number(this.actionValue)) {
        // 改为已签到
        case 1:
          this.changeToSigned(params);
          break;
        // 改为请假
        case 2:
          this.changeToLeave(params);
          break;
        // 改为未签到
        case 3:
          this.changeToNoChecking(params);
          break;
        // 改为请假可退款（工商银行）或者请假生成请假单（平安银行）
        case 4:
          this.changeToLeaveRefund(params);
          break;
        case 5:
          // 改为缺勤
          this.setSignToAbsent();
          break;
        default:
          this.btnLoading = false;
          break;
      }
    },
    // 改变成已签到
    async changeToSigned(params) {
      try {
        const res = await courseSchedulCenter.batchSetToSignedApi(params);
        if (res.status === 200) {
          this.$Message.success('修改成功');
          this.cellList = [];
          this.selectedColumnKey = [];
          this.getStudentAttendance();
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.btnLoading = false;
      }
    },
    // 改变成未签到
    async changeToNoChecking(params) {
      try {
        const res = await courseSchedulCenter.batchSetToNoCheckingApi(params);
        if (res.status === 200) {
          this.$Message.success('修改成功');
          this.cellList = [];
          this.selectedColumnKey = [];
          this.getStudentAttendance();
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.btnLoading = false;
      }
    },
    // 改变成已请假
    async changeToLeave(params) {
      try {
        const list = this.cellList.map(item => {
          return {
            ...item,
            retMoneyEnum: 'NOT_REFUND' // 可退款
          };
        });
        const res = await courseSchedulCenter.batchSaveLeaveApi(
          list
        );
        if (res.status === 200) {
          this.$Message.success('修改成功');
          this.cellList = [];
          this.selectedColumnKey = [];
          this.getStudentAttendance();
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.btnLoading = false;
      }
    },
    // 改变成已请假（可退款）
    async changeToLeaveRefund(params) {
      try {
        const list = this.cellList.map(item => {
          return {
            ...item,
            retMoneyEnum: 'CAN_REFUND' // 可退款
          };
        });
        // return;
        const res = await courseSchedulCenter.batchSaveLeaveApi(
          list
        );
        if (res.status === 200) {
          this.$Message.success('修改成功');
          this.cellList = [];
          this.selectedColumnKey = [];
          this.getStudentAttendance();
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.btnLoading = false;
      }
    },
    //
    async setSignToAbsent() {
      try {
        const params = {
          schoolId: this.searchParams.schoolId,
          termCode: this.searchParams.termCode,
          yearCode: this.searchParams.yearCode,
          signIdList: this.signIds,
          forSignEnum: 5
        };

        const res = await courseSchedulCenter.setSignToAbsent(
          params
        );
        if (res.status === 200) {
          this.$Message.success('修改成功');
          this.cellList = [];
          this.selectedColumnKey = [];
          this.getStudentAttendance();
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.btnLoading = false;
      }
    },

    handleGetSearch(searchParams) {
      this.getMonthList(searchParams.selectMonth);
      const obj = {};
      Object.keys(searchParams).forEach(item => {
        if (this.searchKey.includes(item) && searchParams[item] !== null && searchParams[item] !== undefined) {
          obj[item] = searchParams[item];
        }
      });
      obj.month = `${searchParams.selectMonth}-01 00:00:00`;
      this.searchParams = { ...obj };
      this.pageInfo.pageNum = 1;
      this.getStudentAttendance();
    },
    // 获取学生考勤记录
    async getStudentAttendance() {
      const params = {
        ...this.searchParams,
        pageNum: this.pageInfo.pageNum,
        pageSize: this.pageInfo.pageSize
      };
      this.loading = true;
      this.selectedColumnKey = [];
      this.cellList = [];
      try {
        const res = await eduCenter.getClassSignsPerMonthPageApi(params);

        if (res.status === 200) {
          this.tableData = res.message.list.map(item => {
            const dayObjCopy = JSON.parse(JSON.stringify(this.dayObj));
            const { signInfoList, ...otherInfo } = item;
            if (signInfoList) {
              signInfoList.forEach(x => {
                // signStatue 0和1 都是表示未开始未签到，根据距离开始上课时间是否小于30分钟，来判断是否可以改为已签到
                if (+x.signStatue === 0 || +x.signStatue === 1) {
                  const tag = isPassExpectTime(x.beginTime, 30);
                  tag ? (x.signStatue = 1) : (x.signStatue = 0);
                }
                dayObjCopy[x.dateStr].push({
                  ...x,
                  ...otherInfo
                });
              });
            }
            return {
              studentName: item.studentName,
              gradeAndClass: `${item.gradeName}${item.className}`,
              ...dayObjCopy
            };
          });
          this.pageInfo.total = Number(res.message.total);
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.loading = false;
      }
    },
    getMonthList(monthStr) {
      this.dayObj = {};
      const year = monthStr.substring(0, 4);
      const month = monthStr.substring(5);
      const list = getDaysInMonth(year, month).map(item => {
        const monthFormatStr = item.substring(5); // 示例： 06-01
        this.dayObj[`${monthFormatStr}`] = [];

        return {
          title: monthFormatStr,
          key: monthFormatStr,
          minWidth: 120,
          align: 'center',
          className: 'table-status-column cursor-pointer',
          renderHeader: (h, { column, index }) => {
            const tag = this.selectedColumnKey.includes(monthFormatStr);
            const clickTableHeader = () => {
              this.handleClickTableColumn(monthFormatStr, item);
            };
            return h(
              'div',
              {
                on: {
                  click: clickTableHeader
                }
              },
              [
                h('div', [monthFormatStr]),
                h('div', [getWeekText(item)]),
                h('div', {
                  class: {
                    'block-bg': true,
                    'block-bg-active': tag
                  }
                }, [''])
              ]
            );
          },
          render: (h, { row, column, index }) => {
            return h(
              'div', [
                row[monthFormatStr] ? row[monthFormatStr].length === 0
                  ? h('div', {
                    style: {
                      color: '#999'
                    }
                  }, ['当日无课'])
                  : row[monthFormatStr].map(x => {
                    const clickTableItem = () => {
                      this.handleClickTableItem(x);
                    };
                    const clickLeave = leaveSelectIndex => {
                      this.handleOpenChangeModal(leaveSelectIndex);
                    };
                    const hasSelected = this.signIds.includes(x.signId);
                    const selectIndex = this.signIds.findIndex(j => {
                      return j === x.signId;
                    });
                    return h(
                      'div', {
                        class: {
                          'class-box': true,
                          'hasrefund-box': hasRefundTallyStsList.includes(x.tallySts) || x.tallySts === 8 || (this.actionValue === 4 && (x.tallySts === 1 || x.tallySts === 3 || x.tallySts === 4)) || (this.actionValue === 4 && x.refundOrderId && (+x.refundOrderId)),
                          'select-class-box': hasSelected
                        },
                        on: {
                          // 单元格的点击事件
                          click: clickTableItem
                        }
                      }, [
                        h('div', {
                          class: {
                            'classroom-div': true
                          }
                        }, [x.classroomName]), // 节次的课程名称
                        h('div', {
                          class: {
                            'signstatue-span': true,
                            'signstatue-nosign': (!hasRefundTallyStsList.includes(x.tallySts)) && (x.signStatue === 0 || x.signStatue === 1 || x.signStatue === 5 || x.signStatue === 6),
                            // 请假的，紫色字体
                            'signstatue-leave': x.signStatue === 4 || ((!hasRefundTallyStsList.includes(x.tallySts)) && x.signStatue === 5)
                          }
                        }, [
                          hasRefundTallyStsList.includes(x.tallySts) && x.signStatue !== 4 ? '已退款' : changeDictionaries(signStatusList)[x.signStatue],
                          h('span', { style: { color: '#333' }}, [(!hasRefundTallyStsList.includes(x.tallySts)) && x.refundOrderId && (+x.refundOrderId) ? '(待退款)' : '']),
                          h('span', { style: { color: '#333' }}, [(x.tallySts === 1 || x.tallySts === 3 || x.tallySts === 4) ? '(已结算)' : '']),
                          this.showLeaveText(x) ? h('span', { style: { color: '#333' }}, [x.leaveWaitApprove === 'true' ? '(请假待审批)' : x.signStatue === 4 && hasRefundTallyStsList.includes(x.tallySts) ? '(已退款)' : x.signStatue === 4 && x.tallySts === 8 ? '(可退款)' : '']) : '',
                          hasSelected ? h('Icon', {
                            props: {
                              type: 'ios-checkbox',
                              color: 'rgb(54, 112, 232)',
                              size: 14
                            }
                          }) : ''
                        ]), // 节次的考勤状态
                        h('div', {
                          class: {
                            'noshow-leave': true,
                            'showleave-active': (this.actionValue === 4 || this.actionValue === 2) && hasSelected
                          },
                          on: {
                            click: event => {
                              if ((this.actionValue === 4 || this.actionValue === 2) && hasSelected) {
                                clickLeave(selectIndex);
                                event.stopPropagation();
                              }
                            }
                          }
                        }, [
                          selectIndex === -1 ? '' : this.showLeaveReason(this.cellList[selectIndex].leaveDescribe)
                        ]) // 单选到修改考勤状态为请假的时候，展示请假理由
                      ]
                    );
                  }) : ''
              ]
            );
          }
        };
      });
      this.tableColumnShow = this.tableColumn.concat(list);
    },
    // 已请假状态展示 退款状态
    showLeaveText(x) {
      if (x.leaveWaitApprove === 'true' || x.signStatue === 4 && (hasRefundTallyStsList.includes(x.tallySts) || x.tallySts === 8)) {
        return true;
      } else {
        return false;
      }
    },
    // 点击某节课
    handleClickTableItem(x) {
      console.log(x, '点击某节课');
      // 正在处理数据的时候，不可选择或者取消
      if (this.btnLoading) {
        return;
      }
      // 处于 已退款 或者 可退款状态 的，不可选择或者取消
      if (hasRefundTallyStsList.includes(x.tallySts) || x.tallySts === 8) {
        return;
      }
      // 如果有退款单的，就不能点击
      if (this.actionValue === 4 && (x.tallySts === 1 || x.tallySts === 3 || x.tallySts === 4)) {
        // this.$Message.error('已结算的不能修改为请假（可退款）!');
        return;
      }
      // 如果有退款单的，就不能点击
      if (this.actionValue === 4 && x.refundOrderId && +x.refundOrderId) {
        // this.$Message.error('待退款的不能修改为请假（可退款）!');
        return;
      }
      // 请假已审批的
      // if (x.leaveWaitApprove === 'false' && x.signStatue === 4) {
      //   return;
      // }
      const index = this.signIds.findIndex(item => {
        return x.signId === item;
      });
      if (index !== -1) {
        this.cellList.splice(index, 1);
        return;
      }
      if (!isPassExpectTime(x.beginTime, 30) && this.actionValue === 1) {
        this.$Message.error('当前选择节次还未到可以签到时间');
        return;
      }
      // if (!isPassExpectTime(x.beginTime, 30) && this.actionValue === 5) {
      //   this.$Message.error('当前选择节次还未到可以改为缺勤的时间');
      //   return;
      // }
      const tag = this.judgeStatusCanChange(x.signStatue, true);
      if (!tag) {
        return;
      } else {
        this.cellList.push({ ...x, leaveDescribe: '请假' });
      }
    },
    // 点击某一列
    handleClickTableColumn(key, classTimeBegin) {
      console.log(classTimeBegin, '点击某列----');
      if (this.btnLoading) {
        return;
      }
      console.log('点击了0000', new Date().getTime());
      if (!isPassExpectTime(`${classTimeBegin} 00:00:00`, 30) && this.actionValue === 1) {
        this.$Message.error('当前选择节次还未到可以签到时间');
        return;
      }
      // if (!isPassExpectTime(`${classTimeBegin} 00:00:00`, 30) && this.actionValue === 5) {
      //   this.$Message.error('当前选择节次还未到可以改为缺勤的时间');
      //   return;
      // }
      console.log('==545646==');
      const index = this.selectedColumnKey.findIndex(item => {
        return key === item;
      });
      // 获取点击列的 满足条件的 节次的 signId
      let cellTempList = [];
      this.tableData.forEach(item => {
        const list = [];
        item[key].forEach(x => {
          if (hasRefundTallyStsList.includes(x.tallySts) || x.tallySts === 8) {

          } else if (this.actionValue === 4 && (x.tallySts === 1 || x.tallySts === 3 || x.tallySts === 4)) {

          } else if (this.actionValue === 4 && x.refundOrderId && +x.refundOrderId !== 0) {

          } else if (this.judgeStatusCanChange(x.signStatue, false)) {
            list.push({ ...x, leaveDescribe: '请假' });
          }
        });
        cellTempList = cellTempList.concat(list);
      });

      if (cellTempList.length + this.cellList.length > 200 && index === -1) {
        this.$Message.error('单次最多限制处理200条数据');
        return;
      }

      if (index === -1) {
        this.cellList = this.cellList.concat(cellTempList);
        this.selectedColumnKey.push(key);
      } else {
        this.cellList = this.cellList.filter(item => {
          const index = cellTempList.findIndex(x => {
            return x.signId === item.signId;
          });
          return index === -1;
        });
        this.selectedColumnKey.splice(index, 1);
      }
      console.log('处理了11111', this.cellList, this.selectedColumnKey, new Date().getTime());
    },
    // 判断当前状态是否能修改成别的状态
    judgeStatusCanChange(status, showToast = true) {
      console.log('修改为别的状态，', status, showToast);
      // status 0未开始1未考勤2签到3签退4请假5缺席6停课
      // actionValue(选中哪个选项) 1:改为已签到 2:改为已请假 3:改为未签到 4:改为已请假(可退款) 5
      // （备注）actionValue 2、4的判断条件一致

      // return true

      let clickStatus = false;

      console.log(this.actionValue, status);
      switch (Number(status)) {
        // 未开始的考勤状态 (未开始可以去请假)
        case 0:
          clickStatus = this.actionValue === 2 || this.actionValue === 4;
          break;
        // 未签到的考勤状态 （未签到可以去 签到、请假、或者标记为缺勤）
        case 1:
          clickStatus =
            this.actionValue === 1 ||
            this.actionValue === 2 ||
            this.actionValue === 4 || this.actionValue === 5;
          break;
        // 签退的考勤状态
        case 3:
          clickStatus = this.actionValue === 1 || this.actionValue === 5;
          break;
          // 签到的考勤状态
        case 2:
          clickStatus = this.actionValue === 2 || this.actionValue === 4 || this.actionValue === 3 || this.actionValue === 5;
          break;
        // 已请假考勤状态
        case 4:
          clickStatus = this.actionValue === 1 || this.actionValue === 5;
          break;
        // 缺勤的考勤状态
        case 5:
          clickStatus =
            this.actionValue === 1 ||
            this.actionValue === 2 ||
            this.actionValue === 4;
          break;
      }
      if (!clickStatus && showToast) {
        this.$Message.error(`当前状态无法${this.actionValueStr}`);
      }
      return clickStatus;
    },
    // 展示请假理由
    showLeaveReason(leaveDescribe, ellipsis = true) {
      let leaveDescribeShow = leaveDescribe;
      if (leaveDescribe.length > 4 && ellipsis) {
        leaveDescribeShow = leaveDescribe.slice(0, 4) + '...';
      }
      return leaveDescribeShow;
    },
    // 打开改变请假理由的弹窗
    handleOpenChangeModal(index) {
      this.selectLeaveIndex = index;
      this.leaveReason = this.cellList[index].leaveDescribe;
      this.showSettingReasonModal = true;
    },
    handleChangeLeaveReason() {
      const obj = this.cellList[this.selectLeaveIndex];
      obj.leaveDescribe = this.leaveReason;
      this.cellList.splice(this.selectLeaveIndex, 1, obj);
      this.showSettingReasonModal = false;
    },
    handleCancel() {
      this.showSettingReasonModal = false;
    },
    getNewPage(page) {
      this.tableData = [];
      this.pageInfo.pageNum = page;
      this.getStudentAttendance();
    },
    // 页条数改变
    handlePageSize(pageSize) {
      this.tableData = [];
      this.pageInfo.pageSize = pageSize;
      this.pageInfo.pageNum === 1 && this.getStudentAttendance();
    }

  }
};
</script>
<style lang="scss" scoped>
/deep/.ivu-table th.table-column-td-active {
  background: rgb(254, 247, 247);
}
/deep/.ivu-table th.table-status-column {
  width: 100%;
  height: 100%;
  padding: 0;
  .ivu-table-cell {
    width: 100%;
    height: 100%;
    padding: 0;
    & > div {
      padding: 8px 0;
      position: relative;
      .block-bg {
        position: absolute;
        width: 32px;
        height: 32px;
        right: 0;
        top: 0;
        border-radius: 0 0 0 32px;
        // cursor: pointer;
      }
      .block-bg-active {
        background: #488ffa;
        &::before {
          content: '√';
          color: #fff;
          font-size: 18px;
          right: 6px;
          top: 4px;
          position: absolute;
        }
      }
    }
  }
}
/deep/.ivu-table td.table-column-td-active {
  background: rgb(254, 247, 247);
}
/deep/.ivu-table td.table-status-column {
  width: 100%;
  height: 100%;
  padding: 0;
  .ivu-table-cell {
    width: 100%;
    height: 100%;
    padding: 0;
    .table-column-item {
      width: 100%;
      height: 100%;
    }
    .class-box {
      padding: 12px 4px;
      position: relative;
      .classroom-div {
        font-size: 14px;
        line-height: 20px;
      }
      .signstatue-span {
        font-size: 12px;
        line-height: 20px;
      }
      .signstatue-nosign {
        color: red;
      }
      .signstatue-leave {
        color: blue;
      }
      .signstatue-absence {
        color: #63a103;
      }
      .noshow-leave {
        position: absolute;
        left: 0;
        bottom: 0;
        opacity: 0;
      }
      .showleave-active {
        width: 100%;
        height: 16px;
        position: absolute;
        left: 0;
        bottom: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0 8px;
        font-size: 8px;
        opacity: 1;
        background: rgba(212, 211, 211, 0.3);
        color: #19be6b;
      }
    }
    .hasrefund-box {
      background: #f8f8f9;
      opacity: 0.8;
    }
    .select-class-box {
      background: rgba(0, 100, 244, 0.1);
    }
    .class-box + .class-box {
      border-top: 1px solid #e9ebed;
    }
  }
}
.page-right {
  text-align: right;
  margin-top: 16px;
}
.title-430 {
  font-weight: bold;
}
</style>
